import {createFileRoute} from '@tanstack/react-router';

import {userKeys} from '@/features/User/api/queryKeys';
import {getUser} from '@/features/User/api/readUser';
import {UserProfile} from '@/features/User/components/UserProfile/UserProfile';
import {makeDocumentTitle} from '@/utils/makeDocumentTitle';

export const Route = createFileRoute('/_b/_p/_company/users_/$userId')({
  component: UserProfile,

  beforeLoad: ({params, context}) => {
    makeDocumentTitle(params.userId);

    return {
      ...context,
      readUserQuery: {
        queryKey: userKeys.detail(params.userId),
        queryFn: () => getUser(params.userId),
      },
    };
  },

  loader({context}) {
    return context.queryClient.ensureQueryData(context.readUserQuery);
  },
});
